module.exports = __webpack_public_path__ + "static/media/wave-background-purple.4c1696c2.png";